import { SvgIcon, SvgIconProps } from '@mui/material';

const Add = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 14, height: 14, fill: 'none', ...props?.sx }}
    data-testid="addIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.333008 7.00065C0.333008 3.31875 3.31778 0.333984 6.99967 0.333984C10.6816 0.333984 13.6663 3.31875 13.6663 7.00065C13.6663 10.6826 10.6816 13.6673 6.99967 13.6673C3.31778 13.6673 0.333008 10.6826 0.333008 7.00065ZM6.99967 1.57054C4.00071 1.57054 1.56957 4.00169 1.56957 7.00065C1.56957 9.99962 4.00071 12.4308 6.99967 12.4308C9.99864 12.4308 12.4298 9.99962 12.4298 7.00065C12.4298 4.00169 9.99864 1.57054 6.99967 1.57054ZM6.2467 3.92029C6.2467 3.50444 6.58382 3.16732 6.99967 3.16732C7.41553 3.16732 7.75265 3.50444 7.75265 3.92029V6.24767H10.08C10.4959 6.24767 10.833 6.58479 10.833 7.00065C10.833 7.41651 10.4959 7.75363 10.08 7.75363L7.75265 7.75363V10.081C7.75265 10.4969 7.41553 10.834 6.99967 10.834C6.58382 10.834 6.2467 10.4969 6.2467 10.081V7.75363L3.91932 7.75363C3.50346 7.75363 3.16634 7.41651 3.16634 7.00065C3.16634 6.58479 3.50346 6.24767 3.91932 6.24767H6.2467V3.92029Z"
      fill={props?.fill || '#115DC4'}
    />
  </SvgIcon>
);

export default Add;
